import { TePlaceholderContainer } from '@topcon/tuicl-react';

interface EmptyStateProps {
  /** Primary message. In the loading variant this is the loader caption. */
  text: string;
  /** Secondary message. Ignored while `loading`. */
  subtext?: string;
  /** Icon name from the icon pack. Ignored while `loading`. */
  icon?: string;
  /** When true, renders the loader variant instead of the icon/subtext. */
  loading?: boolean;
}

/**
 * Reusable placeholder for the empty / loading state of a page's content
 * region. Thin, TUICL-first wrapper over `TePlaceholderContainer` so all
 * placeholder styling lives in one spot.
 */
function EmptyState({ text, subtext, icon, loading = false }: EmptyStateProps) {
  return (
    <TePlaceholderContainer
      grow
      loader={loading}
      icon={loading ? undefined : icon}
      text={text}
      subtext={loading ? undefined : subtext}
      backgroundColor="background.secondary"
      borderRadius={4}
    />
  );
}

export default EmptyState;
export type { EmptyStateProps };
